import { confidenceDisplay } from "@/lib/trust";

interface IncidentConfidencePanelProps {
  /** @deprecated Numeric scores are not shown as AI confidence. Kept for call-site compat. */
  confidence?: number | null;
  reasons: string[];
  verified?: boolean;
}

export function IncidentConfidencePanel({ reasons, verified }: IncidentConfidencePanelProps) {
  const display = confidenceDisplay({ verified, reasons });

  return (
    <section className="iw-confidence" aria-label="Evidence status">
      <div className="iw-confidence__score">
        <span className="iw-confidence__label">Evidence status</span>
        <span className={`iw-confidence__value iw-confidence__value--${display.kind}`}>
          {display.label}
        </span>
      </div>
      {!verified && reasons.length > 0 ? (
        <div className="iw-confidence__reasons">
          <span className="iw-confidence__reasons-title">Supporting evidence</span>
          <ul className="iw-confidence__list">
            {reasons.map((reason) => (
              <li key={reason}>
                <span className="iw-confidence__check" aria-hidden="true">
                  ✓
                </span>
                {reason}
              </li>
            ))}
          </ul>
        </div>
      ) : verified ? (
        <p className="iw-confidence__verified-note">Verified by Runtime Doctor after mitigation.</p>
      ) : (
        <p className="iw-confidence__verified-note">Confidence unavailable — no scored model output.</p>
      )}
    </section>
  );
}
